var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarFull(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.46 0.509766L13.5374 6.84832L20.4211 7.86432L15.4401 12.7971L16.6156 19.764L10.46 16.4744L4.30346 19.764L5.47904 12.7971L0.498047 7.86432L7.38175 6.84832L10.46 0.509766Z",
    fill: "#FFD166"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.57226 8.2163L5.82814 12.4325C5.94599 12.5493 5.99991 12.7167 5.97194 12.8812L4.96718 18.8341L10.2288 16.0236C10.3736 15.9454 10.5484 15.9454 10.6933 16.0236L15.9529 18.8341L14.9491 12.8812C14.9212 12.7167 14.9751 12.5493 15.093 12.4325L19.3488 8.2163L13.4659 7.34848C13.3041 7.32412 13.1623 7.22057 13.0904 7.07036L10.4605 1.6544L7.83069 7.07036C7.75778 7.22057 7.61698 7.32412 7.45517 7.34848L1.57226 8.2163ZM16.6171 20.2692C16.5362 20.2692 16.4573 20.2499 16.3844 20.2104L10.4605 17.0467L4.5367 20.2104C4.3689 20.3007 4.16414 20.2865 4.01032 20.1718C3.85651 20.0581 3.7796 19.8663 3.81156 19.6765L4.94319 12.9725L0.150967 8.22541C0.0141317 8.09042 -0.0337941 7.88844 0.024136 7.70574C0.0830649 7.52102 0.239867 7.38805 0.427641 7.35963L7.05066 6.38222L10.0131 0.283172C10.097 0.10961 10.2708 0 10.4605 0C10.6513 0 10.8251 0.10961 10.909 0.283172L13.8704 6.38222L20.4934 7.35963C20.6812 7.38805 20.838 7.52102 20.8969 7.70574C20.9549 7.88844 20.9059 8.09042 20.7701 8.22541L15.9779 12.9725L17.1095 19.6765C17.1415 19.8663 17.0646 20.0581 16.9098 20.1718C16.8239 20.2368 16.72 20.2692 16.6171 20.2692Z",
    fill: "#FFD166"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFull);
export default __webpack_public_path__ + "static/media/star-full.3a7c757f.svg";
export { ForwardRef as ReactComponent };